export default "__VITE_ASSET__WiapIsKS__"